export default "__VITE_ASSET__32adc358__"